var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#51CDA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5766 18.9644L14.0512 13.0701C13.9251 13.0108 13.7847 12.9884 13.6464 13.0057C13.5081 13.0229 13.3775 13.079 13.2698 13.1675C13.1621 13.256 13.0817 13.3732 13.0379 13.5056C12.9942 13.6379 12.9889 13.78 13.0226 13.9152L13.9156 17.4879L19.6317 19.6312L13.9156 21.7746L13.0226 25.3473C12.9883 25.4826 12.9931 25.6249 13.0367 25.7576C13.0802 25.8903 13.1606 26.0078 13.2685 26.0965C13.3764 26.1851 13.5073 26.2412 13.6459 26.2582C13.7845 26.2752 13.9251 26.2524 14.0512 26.1924L26.5766 20.298C26.7032 20.2385 26.8103 20.1442 26.8852 20.0262C26.9602 19.9081 27 19.7711 27 19.6312C27 19.4914 26.9602 19.3544 26.8852 19.2363C26.8103 19.1182 26.7032 19.0239 26.5766 18.9644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b1227918ae39f1e68a79622e839047aa.svg";
export { ForwardRef as ReactComponent };